const CACHE_BUCKET_KEY = "API_CACHE_V1";

const readBucket = () => {
  try {
    return JSON.parse(sessionStorage.getItem(CACHE_BUCKET_KEY)) || {};
  } catch (e) {
    return {};
  }
};

const writeBucket = (bucket) => {
  try {
    sessionStorage.setItem(CACHE_BUCKET_KEY, JSON.stringify(bucket));
  } catch (e) {
    // ignore storage quota errors
  }
};

export const getCachedValue = (key) => {
  const bucket = readBucket();
  const entry = bucket[key];
  if (!entry) return null;

  if (entry.expiry && entry.expiry > Date.now()) {
    return entry.value;
  }

  // expired -> cleanup
  delete bucket[key];
  writeBucket(bucket);
  return null;
};

export const setCachedValue = (key, value, ttlMs = 5 * 60 * 1000) => {
  const bucket = readBucket();
  bucket[key] = {
    value,
    expiry: Date.now() + ttlMs,
  };
  writeBucket(bucket);
};
